//这里是 售后工单 模块的路由文件

const basePath = "/admin/order/";
export default [
    //工单列表
    {
        path: `${basePath}list`,
        name: 'OrderList',
        component: r => require.ensure([], () => r(require('@/views/order/OrderList')), 'Order')
    },
    //工单详情
    {
        path: `${basePath}des`,
        name: 'OrderDescription',
        component: r => require.ensure([], () => r(require('@/views/order/OrderDescription')), 'Order')
    },
    //工单创建
    {
        path: `${basePath}create`,
        name: 'OrderCreate',
        component: r => require.ensure([], () => r(require('@/views/order/OrderCreate')), 'Order')
    },
    //配件订单
    {
        path: `${basePath}list/parts`,
        name: 'OrderListParts',
        component: r => require.ensure([], () => r(require('@/views/order/OrderListParts')), 'Order')
    },
    //配件订单详情
    {
        path: `${basePath}list/parts/des`,
        name: 'OrderPartsDescription',
        component: r => require.ensure([], () => r(require('@/views/order/OrderPartsDescriptionV2')), 'Order')
    },
    //外派服务单
    {
        path: `${basePath}expatriate`,
        name: 'OrderExpatriate',
        component: r => require.ensure([], () => r(require('@/views/order/OrderExpartiate')), 'Order')
    },
    //外派服务单详情
    {
        path: `${basePath}expatriate/des`,
        name: 'ExpartiateDescription',
        component: r => require.ensure([], () => r(require('@/views/order/ExpartiateDescriptionViewV2')), 'Order')
    },
    //工单类型管理
    {
        path: `${basePath}status`,
        name: 'OrderStatus',
        component: r => require.ensure([], () => r(require('@/views/order/OrderStatus')), 'Order')
    },

]
